(function () {
  if (window.PJXHubSpotForms) return;

  function toElement(source) {
    if (!source) return null;
    if (source.nodeType === 1) {
      return source.matches('form') ? source : source.querySelector('form');
    }
    if (typeof source.get === 'function') {
      return toElement(source.get(0));
    }
    if (source[0]) {
      return toElement(source[0]);
    }
    return null;
  }

  function inputForField(field) {
    return field.querySelector('input[name]:not([type="hidden"]), select[name], textarea[name]');
  }

  function fieldKey(field) {
    var input = inputForField(field);
    var name = input && input.getAttribute('name') ? input.getAttribute('name') : '';
    var classes = field.className || '';
    return (name + ' ' + classes).toLowerCase();
  }

  function isFirstName(field) {
    return /(^|[\s_-])firstname($|[\s_-])|(^|[\s_-])first_name($|[\s_-])|hs_firstname/.test(fieldKey(field));
  }

  function isLastName(field) {
    return /(^|[\s_-])lastname($|[\s_-])|(^|[\s_-])last_name($|[\s_-])|hs_lastname/.test(fieldKey(field));
  }

  function removeLayoutStyles(field) {
    field.classList.add('pjx-hs-field');
    field.removeAttribute('style');

    field.querySelectorAll('label, .input, input, select, textarea').forEach(function (node) {
      if (node.matches('input[type="hidden"]')) return;
      node.removeAttribute('style');
      node.removeAttribute('size');
    });
  }

  function makeRow(twoColumn) {
    var row = document.createElement('div');
    row.className = twoColumn ? 'pjx-hs-row pjx-hs-row--two' : 'pjx-hs-row';
    return row;
  }

  function moveLegalContent(form, beforeNode) {
    form.querySelectorAll('.legal-consent-container, .hs-richtext').forEach(function (node) {
      if (node.closest('.pjx-hs-row')) return;
      if (beforeNode && node.compareDocumentPosition(beforeNode) & Node.DOCUMENT_POSITION_FOLLOWING) return;
      form.insertBefore(node, beforeNode || null);
    });
  }

  function hideEmptyFieldsets(form) {
    form.querySelectorAll('fieldset').forEach(function (fieldset) {
      if (fieldset.querySelector('.hs-form-field, input:not([type="hidden"]), select, textarea, .legal-consent-container, .hs-richtext')) return;
      fieldset.classList.add('pjx-hs-fieldset--empty');
    });
  }

  function normalize(source) {
    var form = toElement(source);
    if (!form || form.dataset.pjxHubspotNormalized === 'true') return;

    var fields = Array.prototype.slice.call(form.querySelectorAll('.hs-form-field'));
    if (!fields.length) return;

    form.dataset.pjxHubspotNormalized = 'true';
    form.classList.add('pjx-hs-form');

    fields.forEach(removeLayoutStyles);

    var firstName = fields.find(isFirstName);
    var lastName = fields.find(isLastName);
    var pairedNameRowAt = -1;

    if (firstName && lastName) {
      pairedNameRowAt = Math.min(fields.indexOf(firstName), fields.indexOf(lastName));
    }

    var submit = form.querySelector('.hs-submit') || form.querySelector('.actions');
    var grid = document.createElement('div');
    grid.className = 'pjx-hs-grid';
    form.insertBefore(grid, submit || null);

    fields.forEach(function (field, index) {
      if ((field === firstName || field === lastName) && index !== pairedNameRowAt) return;

      var row = makeRow(index === pairedNameRowAt && firstName && lastName);

      if (index === pairedNameRowAt && firstName && lastName) {
        row.appendChild(firstName);
        row.appendChild(lastName);
      } else {
        row.appendChild(field);
      }

      grid.appendChild(row);
    });

    moveLegalContent(form, submit || null);
    hideEmptyFieldsets(form);
  }

  function normalizeWhenReady(source) {
    var attempts = 0;

    function run() {
      var form = toElement(source);
      if (form && form.querySelector('.hs-form-field')) {
        normalize(form);
        return;
      }
      attempts += 1;
      if (attempts < 40) {
        window.setTimeout(run, 75);
      }
    }

    run();
  }

  window.PJXHubSpotForms = {
    normalize: normalizeWhenReady
  };
})();
